export const DOMAIN = {
  beta: 'test',
  gamma: 'test',
  prod: 'prod',
};

export const REALM = {
  'eu-west-1': 'EUAmazon',
  'us-east-1': 'USAmazon',
  'us-west-2': 'FEAmazon',
};

export const SITE = {
  beta: 'AACChrome.Beta',
  gamma: 'AACChrome.Gamma',
  prod: 'AACChrome.Prod',
};

const footerToggleEndpoint = '/common/forceDesktopSite?force_desktop_site=';
export const FOOTER_FORCE_DESKTOP_ENDPOINT = `${footerToggleEndpoint}true&ref=`;
export const FOOTER_FORCE_MOBILE_ENDPOINT = `${footerToggleEndpoint}false&ref=`;
export const CONSOLE_HEADER_SECTION_ID = '#console-header-section';
export const CONSOLE_HEADER_RESIZE_EVENT = 'ChromeHeaderResize';
export const MOBILE_MENU_Z_INDEX = 398; // mobile menu
export const MOBILE_MENU_SUB_MENU_Z_INDEX = 399; // account, user preferences and tools menu

export enum WeblabedFeatures {
  AAC_WEBLAB_TEST = 'AAC_WEBLAB_TEST', // This weblab doesn't exist and is only used for testing purposes
  STARDUST_BANNER_UI = 'STARDUST_BANNER_UI',
  CONTEXT_SERVICE_ADSP_GLOBAL_ACCOUNT = 'CONTEXT_SERVICE_ADSP_GLOBAL_ACCOUNT',
  HELP_ME_HERE_SGA_TOOLTIP = 'HELP_ME_HERE_SGA_TOOLTIP',
  ADS_NAVIGATOR_P0 = 'ADS_NAVIGATOR_P0',
  ADS_AGENT_P0 = 'ADS_AGENT_P0',
  ADS_AGENT_EMBEDDED = 'ADS_AGENT_EMBEDDED',
  CHROME_THEME_MODES_CONTROL = 'CHROME_THEME_MODES_CONTROL',
  NAV_ADS_PROD = 'NAV_ADS_PROD',
  HMH_LAZY_LOAD = 'HMH_LAZY_LOAD',
}

export enum Components {
  HEADER = 'AACChromeHeader',
  FOOTER = 'AACChromeFooter',
  NAV = 'AACChromeNav',
  PIVOT_NAV = 'AACChromePivotNav',
  PAGE_HEADER = 'AACChromePageHeader',
  GLOBAL_HEADER = 'AACChromeGlobalHeader',
  MARKETPLACE_SWITCHER = 'AACChromeMarketplaceSwitcher',
}

export const CHROME_APP_NAME = {
  Header: 'Header',
  Nav: 'Nav',
  PivotNav: 'PivotNav',
  Footer: 'Footer',
  GlobalHeader: 'GlobalHeader',
  PageHeader: 'PageHeader',
  MarketplaceSwitcher: 'MarketplaceSwitcher',
};

export const staticImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo._CB564109095_.svg';
export const staticInternalImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-internal-logo._CB564109095_.svg';
export const staticImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo.svg';
export const staticInternalImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-internal-logo.svg';
// TODO: add the dark logo to the GlobalNavHandler.java
// https://code.amazon.com/packages/AACChromeGlobalNav/blobs/73564f48db090e0d28daccaf711b5136de72fc07/--/src/com/amazon/aac/chrome/globalnav/handler/GlobalNavHandler.java#L196-L204
export const staticDarkImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo-dark._CB1762968808_.svg';
export const staticDarkImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo-dark.svg';

export const spoofingQueryParamName = 'kerberos';
export const quitSpoofingQueryParamValue = 'off';
export const ATC_EXTERNAL_TOGGLE = 'ATC_EXTERNAL_TOGGLE';
export const SALES_ASSISTANT_LOADED = 'SALES_ASSISTANT_LOADED';
export const CC_MODAL_TOOLBAR_ID = 'aac-toolbar-item-create-campaign-modal';
export const CC_MODAL_BULLSEYE_TOOLBAR_ID =
  'aac-toolbar-item-create-campaign-modal-front-end';
export const CC_MODAL_MENU_ITEM_TOOLBAR_ID =
  'aac-menu-item-unified-campaign-creation';
export const CM_TOOLBAR_ID = 'aac-toolbar-item-sponsored-ads';
